import { VIDEO_TO_911_SHARE_TELNYX } from '@rsos/capstone/src/constants/capabilities';

/**
 * Function to determine if the current user's authority has the
 * `video_to_911_responder_share` capability turned on
 * @param {Object} psaps - PSAPS reducer
 */
const isVideoTo911ShareTelnyxEnabled = (psaps: {
  currentPSAP: {
    activeCapabilities: { [VIDEO_TO_911_SHARE_TELNYX]: boolean };
  };
}) => {
  return !!psaps.currentPSAP?.activeCapabilities?.[VIDEO_TO_911_SHARE_TELNYX];
};

export default isVideoTo911ShareTelnyxEnabled;
